import { createContext } from "react";

export const PlayBackContext = createContext()
export const PaymentContext = createContext()
export const MapContext = createContext()
export const SmartReportContext = createContext()
export const SettingAIContext = createContext()
export const TracingEventContext = createContext()
export const WaitConfirmContext = createContext()
export const AddNewUserContext = createContext()
export const LisencePlateContext = createContext()
export const LisencePlateManagerContext = createContext()